import T from 'prop-types'
import Button from 'components/Button'
import Joi from 'joi'

import Step from '../../components/Step'
import getGenderText from '../../helpers/getGenderText'

export const validator = () =>
  Joi.object({
    vaccination: Joi.object({
      self_declaration: Joi.array().items(
        Joi.object({
          question: Joi.string().valid('HAS_PREVIOUS_VACCINE_REACTIONS'),
          answer: Joi.boolean(),
        }),
      ),
    }),
  })
    .required()
    .unknown(true)

export default function Allergy({ changeStep, values, onChange }) {
  const hasAllergies = values?.vaccination?.self_declaration.some(
    ({ question, answer }) => question === 'HAS_PREVIOUS_VACCINE_REACTIONS' && answer === true,
  )

  const handleChange = (answer) => () => {
    onChange('vaccination.self_declaration', [
      {
        question: 'HAS_PREVIOUS_VACCINE_REACTIONS',
        answer,
      },
    ])
  }

  const title = getGenderText('Har %s hatt allergiske reaksjoner på en vaksine tidligere?', values)

  const info = getGenderText(
    'Om %s har hatt allergiske reaksjoner tidligere må %s opplyse personalet på vaksinestedet om dette før %s tar vaksinen.',
    values,
  )

  return (
    <Step
      title={title}
      info={info}
      onSubmit={changeStep}
      submit="Gå videre"
      submitDisabled={hasAllergies === undefined}
    >
      <Button key="yes" inline small onClick={handleChange(true)} selected={hasAllergies === true}>
        Ja, har hatt det
      </Button>
      <Button key="no" inline small onClick={handleChange(false)} selected={hasAllergies === false}>
        Nei, ikke opplevd det
      </Button>
    </Step>
  )
}

Allergy.propTypes = {
  changeStep: T.func.isRequired,
  values: T.object.isRequired,
  onChange: T.func.isRequired,
}
